import { TeamRepository } from '../repositories';

export class DeclineTeamInvitationUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(invitationId: string): Promise<void> {
    await this.teamRepository.updateInvitationStatus(invitationId, 'declined');
  }
}
